import { render } from "./BalanceSheet.vue?vue&type=template&id=35375140&scoped=true"
import script from "./BalanceSheet.vue?vue&type=script&lang=js"
export * from "./BalanceSheet.vue?vue&type=script&lang=js"

import "./BalanceSheet.vue?vue&type=style&index=0&id=35375140&scoped=true&lang=css"

import exportComponent from "D:\\DockerProjects\\armt_pos_v2_docker\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35375140"]])

export default __exports__